module.exports = __webpack_public_path__ + "static/media/CroptixLogoColor.f7f34f28.png";